/**
 * Musetopia - Collection Dynamic SPU Sort Helper
 * 
 * Complements the inline zero-paint engine by:
 * 1. Preserving SPU query parameters across pagination links (page 2, 3, infinite scroll)
 * 2. Re-triggering image lazyloading for dynamically injected cards
 * 3. Listening to collection AJAX filter updates
 */

(function () {
  'use strict';

  function getSpuParam() {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      for (const [key, value] of searchParams.entries()) {
        if (/^(sortby_bestseller|sortby_bestseller|sortby_spu|pin_spus)/i.test(key) && value.trim()) {
          return { key, value: value.trim() };
        }
      }
    } catch (e) {}
    return null;
  }

  function preservePaginationLinks() {
    const paramObj = getSpuParam();
    if (!paramObj) return;

    const paginationLinks = document.querySelectorAll(
      '.pagination a[href], .pagination-num a[href], .pagination-arrow a[href], [data-infinite-scrolling], .cst-featured-collection-pagination a[href]'
    );

    paginationLinks.forEach((link) => {
      try {
        const href = link.getAttribute('href') || link.getAttribute('data-href');
        if (!href || href.startsWith('javascript:') || href === '#') return;
        const targetUrl = new URL(href, window.location.origin);
        if (!targetUrl.searchParams.has(paramObj.key)) {
          targetUrl.searchParams.set(paramObj.key, paramObj.value);
          if (link.hasAttribute('href')) {
            link.setAttribute('href', targetUrl.pathname + targetUrl.search + targetUrl.hash);
          }
          if (link.hasAttribute('data-href')) {
            link.setAttribute('data-href', targetUrl.pathname + targetUrl.search + targetUrl.hash);
          }
        }
      } catch (e) {}
    });
  }

  function refreshLazyloading() {
    if (window.lazySizes && window.lazySizes.autoSizer) {
      window.lazySizes.autoSizer.checkElems();
    }
    window.dispatchEvent(new Event('scroll'));
  }

  // Preserve links on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      preservePaginationLinks();
      refreshLazyloading();
    });
  } else {
    preservePaginationLinks();
    refreshLazyloading();
  }

  // Support AJAX filter updates
  document.addEventListener('collection:updated', () => {
    preservePaginationLinks();
    refreshLazyloading();
  });
})();
